<template>
  <div>
    <dd-customer-page
        :loading-content="!pageLoaded"
        :header="policyHeader"
        :customer-id="customerId"
        :category-id="insuranceCategory"
        :instance="instance"
    >
      <template v-slot:tabs>
        <dd-tab-group v-if="customer">
          <dd-tab>
            <dd-avatar-and-name
                :customer-id="customerId"
                :name="customer.full_name"
            />
          </dd-tab>
        </dd-tab-group>
      </template>
      <template v-slot:content>
        <dd-tab-content-wrapper>
          <dd-tab-content>
            <div v-if="!pageLoaded">
              <dd-loading-indicator message="De polis wordt ingeladen..."></dd-loading-indicator>
            </div>
            <dd-vertical-sub-tabs-layout v-if="pageLoaded">
              <template v-slot:tabs>
                <dd-sub-tab-group  orientation="vertical">

                  <dd-sub-tab @click="onTabClick(tab.form_step)" v-for="(tab, idx) of renderableTabs" :key="idx" >
                    {{ tab.title }}
                  </dd-sub-tab>

                  <dd-sub-tab @click="onTabClick(undefined)">
                    ADN Berichten
                  </dd-sub-tab>

                  <dd-sub-tab data-dusk="policy-documents" @click="onTabClick(undefined)">
                    Documenten
                  </dd-sub-tab>

                  <dd-sub-tab
                      v-if="showCompare"
                      @click="onTabClick(undefined)">
                    Vergelijken
                  </dd-sub-tab>
                </dd-sub-tab-group>
              </template>
              <template v-slot:content>
                <dd-sub-tab-content-wrapper>
                  <dd-sub-tab-content v-for="(tab, idx) of renderableTabs" :key="idx">
                    <dd-customer-page-container>
                      <div class="sections-list flex-col gap-y-md">
                        <dd-header-card
                            class="section"
                            v-for="(section, idx) of tab.sections"
                            :header="section.title"
                            :id="section.id"
                            :data-dusk="section.id"
                            :key="section.id"
                        >
                          <template #action>
                            <div class="flex-row gap-md">
                              <dd-button
                                  v-if="section.title === 'Basis gegevens' && policy.agency"
                                  :small="true"
                                  icon="mdi mdi-phone"
                                  :outline="true"
                              >
                                <AgencyContactDetailsComponent
                                  :id="policy.agency.id"
                                />
                              </dd-button>
                              <dd-button @click="onSectionEditClick(section.title)" class="square-button" :small="true">
                                <template #icon>
                                  <PencilIcon/>
                                </template>
                              </dd-button>
                            </div>
                          </template>
                          <dd-card-stacked-list :list="section.fields"></dd-card-stacked-list>
                        </dd-header-card>
                      </div>
                    </dd-customer-page-container>
                  </dd-sub-tab-content>

                  <dd-sub-tab-content>
                    <dd-customer-page-container>
                      <dd-header-card header="ADN Berichten">
                        <PolicySiviMessagesComponent class="width-stretch" :policy-id="policyId.toString()"></PolicySiviMessagesComponent>
                      </dd-header-card>
                    </dd-customer-page-container>
                  </dd-sub-tab-content>

                  <dd-sub-tab-content>
                    <dd-customer-page-container>
                      <attachable-widget-component
                          :has-attachable-type="attachables.hasAttachableType"
                          :is-instance="attachables.isInstance"
                          :category="attachables.category"
                          :has-attachable-id="attachables.hasAttachableId">
                      </attachable-widget-component>
                    </dd-customer-page-container>
                  </dd-sub-tab-content>

                  <dd-sub-tab-content v-if="hasDeathInsurance || hasCarInsurance">
                    <dd-customer-page-container>
                      <dd-header-card header="Vergelijken">
                        <div class="overflow-auto">
                          <compare-death-insurance :customer-id="customerId" :policy-id="policyId" v-if="canUseTopicusCompare && hasDeathInsurance">

                          </compare-death-insurance>
                          <compare-car-insurance :customer-id="customerId" :policy-id="policyId" v-else-if="canUseRollsCompare && hasCarInsurance">

                          </compare-car-insurance>
                        </div>
                      </dd-header-card>
                    </dd-customer-page-container>
                  </dd-sub-tab-content>
                </dd-sub-tab-content-wrapper>
              </template>
            </dd-vertical-sub-tabs-layout>
          </dd-tab-content>
        </dd-tab-content-wrapper>
      </template>
      <template v-slot:buttons>
        <action-buttons v-if="policy && customer">

        </action-buttons>
      </template>
    </dd-customer-page>
  </div>

</template>

<script>
import AttachableWidgetComponent from '../../components/documents/WidgetComponent.vue';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import store from "./store";
import ActionButtons from './components/ActionButtons.vue';
import CompareDeathInsurance from "~/modules/compare/DeathInsurance";
import CompareCarInsurance from "~/modules/compare/CarInsurance";
import PolicySiviMessagesComponent from '~/modules/policy/components/PolicySiviMessagesComponent.vue';
import AttachableCategoryTemplateTypeEnum from "~/enums/AttachableCategoryTemplateTypeEnum";
import HasAttachableTypeEnum from '~/enums/HasAttachableTypeEnum';
import HasAttachableClassEnum from '~/enums/HasAttachableClassEnum';
import SetDefaultContentWidth from '~/mixins/header_page/set_default_content_width';

export default {
  name: "PolicyShowPage.vue",
  mixins: [SetDefaultContentWidth],
  components: {
    PolicySiviMessagesComponent,
    AttachableWidgetComponent,
    CompareCarInsurance,
    CompareDeathInsurance,
    ActionButtons,
  },
  beforeCreate() {
    const STORE_KEY = '$_policy_show'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  data() {
    return {
      coverage: false,
      person: false,
      insurer: false,
    }
  },
  created() {
    this.setCustomerId(this.customerId);
    this.getCustomerById(this.customerId);
    this.setPolicyId(this.policyId);
    this.setPageInstance({
      id: this.policyId,
      type: HasAttachableTypeEnum.POLICY,
      class: HasAttachableClassEnum.POLICY,
    })
    this.setCategory(this.insuranceCategory);
    this.getInitialPolicyShowPageData();
  },
  computed: {
    showCompare() {
      return (this.hasDeathInsurance && this.canUseTopicusCompare) || (this.hasCarInsurance && this.canUseRollsCompare);
    },
    customerId() {
      return this.$route.params?.customer;
    },
    policyId() {
      return this.$route.params.policy;
    },
    hasDeathInsurance() {
      return this.policy?.has_death_insurance;
    },
    hasCarInsurance() {
      return this.policy?.has_car_insurance;
    },
    canUseTopicusCompare() {
      return this.policy?.can['use-topicus-compare-calculators'];
    },
    canUseRollsCompare() {
      return this.policy?.can['use-rolls-compare-calculators'];
    },
    insuranceCategory() {
      return {
        id: AttachableCategoryTemplateTypeEnum.INSURANCE,
        name: 'Polissen',
      };
    },
    ...mapState({
      instance: 'instance',
    }),
    ...mapState(`$_policy_show`, {
      attachables: 'attachables',
      customer: 'customer',
      pageLoaded: 'pageLoaded',
    }),
    ...mapGetters('$_policy_show', {
      policy: 'policy',
      renderableTabs: 'renderableTabs',
      loading: 'loading',
      editPath: 'editPath',
      policyHeader: 'policyHeader',
    }),
  },
  methods: {
    onSectionEditClick(id) {
      this.setActiveSectionId(id);
      this.navigator.navigatePath(this.editPath);
    },
    onTabClick(formStep) {
      this.setActiveStepId(formStep);
    },
    ...mapMutations({
      setPageInstance: 'SET_PAGE_INSTANCE',
      setCategory: 'SET_CATEGORY',
    }),
    ...mapMutations(`$_policy_show`, {
      setPolicyId: 'SET_POLICY_ID',
      setActiveStepId: 'SET_ACTIVE_STEP_ID',
      setActiveSectionId: 'SET_ACTIVE_SECTION_ID',
      setCustomerId: 'SET_CUSTOMER_ID',
    }),
    ...mapActions('$_policy_show', {
      editPolicy: 'editPolicy',
      getCustomerById: 'getCustomerById',
      getInitialPolicyShowPageData: 'getInitialPolicyShowPageData',
      setLoading: 'setLoading',
    }),

  },

}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

</style>
